import { CaseNotificationData, NotificationToastMessageType, NotificationToastType } from '@/api/apis/communication';
import { buildCaseUrl } from '@/utils/helpers';
import { ORGANIZATION_TENANT_PREFIX } from '@/constants/customer.constants';

const ORGANIZATION_ID_PROP_MAPPING: Partial<Record<string, 'TxCenterId' | 'OpoOrganizationId'>> = {
  [ORGANIZATION_TENANT_PREFIX.TxCenter]: 'TxCenterId',
  [ORGANIZATION_TENANT_PREFIX.OPO]: 'OpoOrganizationId',
};

const getOrganizationIdFromNotification = (data: CaseNotificationData): string | undefined => {
  const prefix = localStorage.getItem('selectedOrganizationPrefix') || '';
  const prop = ORGANIZATION_ID_PROP_MAPPING[prefix];
  return prop ? data[prop] : undefined;
};

export const getCaseToastLink = (notification: NotificationToastType, isNopConnectPlatform: boolean) => {
  const { caseId, data, toastType } = notification;
  if (!caseId) return '';

  const baseArgs = {
    caseId,
    ...(!isNopConnectPlatform && { organizationId: getOrganizationIdFromNotification(data) }),
  };

  switch (toastType) {
    case NotificationToastMessageType.RoutePlanningStarted:
    case NotificationToastMessageType.RoutePlanningCompleted:
      return buildCaseUrl({ ...baseArgs, path: 'planner/change-log' });
    case NotificationToastMessageType.CaseRouteUpdated:
      if (!data?.RouteLogId) {
        return buildCaseUrl(baseArgs);
      }

      return buildCaseUrl({ ...baseArgs, path: `planner/change-log#${data.RouteLogId}` });
    case NotificationToastMessageType.CaseBulkOperationPrimaryElevation:
    case NotificationToastMessageType.CaseBulkSwapOperationCompleted:
    case NotificationToastMessageType.CaseBulkAssignOperationCompleted:
    case NotificationToastMessageType.CaseBulkDetachOperationCompleted:
      return undefined;
    default:
      return buildCaseUrl(baseArgs);
  }
};
